import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from 'src/contexts/auth-context';
import PropTypes from 'prop-types';

export const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthContext();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
   
    if (window.sessionStorage.getItem('token')==null) {
      navigate('/auth/login', { replace: true, state: { continueUrl: window.location.pathname } });
    } else {
      setChecked(true);
    }
  }, [ navigate]);

  if (!checked) {
    return null; // or a loader/spinner
  }

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};